import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

const PrivacyPolicy = ({ isOpen, onClose }) => {
    return (
        <AnimatePresence>
            {isOpen && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6">
                    {/* Backdrop */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={onClose}
                        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
                    />

                    {/* Modal Content */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.9, y: 20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.9, y: 20 }}
                        className="relative w-full max-w-2xl bg-white rounded-[2.5rem] shadow-2xl overflow-hidden max-h-[80vh] flex flex-col"
                    >
                        {/* Header */}
                        <div className="p-6 sm:p-8 flex items-center justify-between border-b border-gray-100">
                            <h2 className="text-xl sm:text-2xl font-bold text-primary">Privacy Policy</h2>
                            <button
                                onClick={onClose}
                                className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                            >
                                <X className="w-6 h-6 text-primary" />
                            </button>
                        </div>

                        {/* Body - Scrollable */}
                        <div className="p-6 sm:p-8 overflow-y-auto font-sans text-primary/80 leading-relaxed text-sm sm:text-base">
                            <section className="mb-6">
                                <h3 className="font-bold text-primary mb-2">1. Information We Collect</h3>
                                <p>We only collect personal information that you voluntarily provide through our inquiry forms, such as your name, contact number, and email address. This information is used strictly to process your request for redevelopment or real estate consultancy.</p>
                            </section>

                            <section className="mb-6">
                                <h3 className="font-bold text-primary mb-2">2. How We Use Informaton</h3>
                                <p>Your data is used solely to contact you regarding your inquiry. We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties.</p>
                            </section>

                            <section className="mb-6">
                                <h3 className="font-bold text-primary mb-2">3. Data Protection</h3>
                                <p>We implement a variety of security measures to maintain the safety of your personal information. Our database is secured with modern encryption and access controls.</p>
                            </section>

                            <section className="mb-6">
                                <h3 className="font-bold text-primary mb-2">4. Cookies</h3>
                                <p>Our website uses minimal cookies to improve your user experience and for website analytics. These do not track personal information.</p>
                            </section>

                            <section>
                                <h3 className="font-bold text-primary mb-2">5. Contact Us</h3>
                                <p>If you have any questions regarding this privacy policy, you may contact us using the information on our website.</p>
                            </section>
                        </div>

                        {/* Footer */}
                        <div className="p-6 bg-gray-50 flex justify-end">
                            <button
                                onClick={onClose}
                                className="px-8 py-3 bg-primary text-white font-bold rounded-xl hover:opacity-90 transition-opacity"
                            >
                                Got it
                            </button>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};

export default PrivacyPolicy;
